import { createAction, createReducer } from "@reduxjs/toolkit";
import { get } from "lodash-es";
import { DEFAULT_VIEW_ALL_SIPS_STORAGE, DEFAULT_YOUR_FUNDS_STORAGE, DEFAULT_YOUR_ORDERS_STORAGE } from "../../constants/portfolio";
const MODULE_PREFIX = "[ PortfolioV2 ]";
const Actions = {
  getPortfolioSummary: `${MODULE_PREFIX} getPortfolioSummary`,
  setPortfolioSummary: `${MODULE_PREFIX} setPortfolioSummary`,
  getMfPortfolioSummary: `${MODULE_PREFIX} getMfPortfolioSummary`,
  setMfPortfolioSummary: `${MODULE_PREFIX} setMfPortfolioSummary`,
  setPfStatusCode: `${MODULE_PREFIX} setPfStatusCode`,
  resetPortfolioV2: `${MODULE_PREFIX} resetPortfolioV2`,
  getSwitchFundDetails: `${MODULE_PREFIX} getSwitchFundDetails`,
  setSwitchFundDetails: `${MODULE_PREFIX} setSwitchFundDetails`,
  getAvailableSwitchFunds: `${MODULE_PREFIX} getAvailableSwitchFunds`,
  setAvailableSwitchFunds: `${MODULE_PREFIX} setAvailableSwitchFunds`,
  getCompleteSwitchDetails: `${MODULE_PREFIX} getCompleteSwitchDetails`,
  setMfWalkthroughInitiated: `${MODULE_PREFIX} setMfWalkthroughInitiated`,
  setIsKycBottomSheetOpen: `${MODULE_PREFIX} setIsKycBottomSheetOpen`,
  setIsDormatBottomSheetOpen: `${MODULE_PREFIX} setIsDormatBottomSheetOpen`,
  setIsAccountClosureBottomSheetOpen: `${MODULE_PREFIX} setIsAccountClosureBottomSheetOpen`,
  setMpfStatusCode: `${MODULE_PREFIX} setMpfStatusCode`,
  setSelectedSwitchToFund: `${MODULE_PREFIX} setSelectedSwitchToFund`,
  setSwitchOtpDetails: `${MODULE_PREFIX} setSwitchOtpDetails`,
  getSwitchOtpDetails: `${MODULE_PREFIX} getSwitchOtpDetails`,
  resendSwitchOtpDetails: `${MODULE_PREFIX} resendSwitchOtpDetails`,
  verifySwitchOtp: `${MODULE_PREFIX} verifySwitchOtp`,
  getYourFunds: `${MODULE_PREFIX} getYourFunds`,
  setYourFunds: `${MODULE_PREFIX} setYourFunds`,
  setHoldingFundData: `${MODULE_PREFIX} setHoldingFundData`,
  getFundSips: `${MODULE_PREFIX} getFundSips`,
  setFundSips: `${MODULE_PREFIX} setFundSips`,
  getFundOrders: `${MODULE_PREFIX} getFundOrders`,
  setFundOrders: `${MODULE_PREFIX} setFundOrders`,
  fetchPendingOrders: `${MODULE_PREFIX} fetchPendingOrders`,
  setPendingOrders: `${MODULE_PREFIX} setPendingOrders`,
  setFundOrderData: `${MODULE_PREFIX} setFundOrderData`,
  fetchAllHoldingFunds: `${MODULE_PREFIX} fetchAllHoldingFunds`,
  setMoreTransactionsData: `${MODULE_PREFIX} setMoreTransactionsData`,
  fetchMoreTransactions: `${MODULE_PREFIX} fetchMoreTransactions`,
  updateFundOrders: `${MODULE_PREFIX} updateFundOrders`,
  setOrderDetailsFund: `${MODULE_PREFIX} setOrderDetailsFund`,
  setIsCallPortfolioApis: `${MODULE_PREFIX} setIsCallPortfolioApis`,
  setYourOrdersStorage: `${MODULE_PREFIX} setYourOrdersStorage`,
  resetYourOrdersStorage: `${MODULE_PREFIX} resetYourOrdersStorage`,
  setYourFundsStorage: `${MODULE_PREFIX} setYourFundsStorage`,
  resetYourFundsStorage: `${MODULE_PREFIX} resetYourFundsStorage`,
  setAllSipsData: `${MODULE_PREFIX} setAllSipsData`,
  setUpcomingSipsData: `${MODULE_PREFIX} setUpcomingSipsData`,
  setSelectedSipData: `${MODULE_PREFIX} setSelectedSipData`,
  updateSelectedSip: `${MODULE_PREFIX} updateSelectedSip`,
  updateSipAction: `${MODULE_PREFIX} updateSipAction`,
  setViewAllSipsStorage: `${MODULE_PREFIX} setViewAllSipsStorage`,
  resetViewAllSipsStorage: `${MODULE_PREFIX} resetViewAllSipsStorage`,
  setFundOrderDetails: `${MODULE_PREFIX} setFundOrderDetails`,
  fetchFundOrderDetails: `${MODULE_PREFIX} fetchFundOrderDetails`,
  updateEditSipData: `${MODULE_PREFIX} updateEditSipData`,
  submitSipOtp: `${MODULE_PREFIX} submitSipOtp`,
  fetchExternalPortfolioSummary: `${MODULE_PREFIX} fetchExternalPortfolioSummary`,
  setExternalPortfolioSummary: `${MODULE_PREFIX} setExternalPortfolioSummary`,
  fetchSwitchTaxes: `${MODULE_PREFIX} fetchSwitchTaxes`,
};

// Actions
export const getPortfolioSummary = createAction(Actions.getPortfolioSummary);
export const setPortfolioSummary = createAction(Actions.setPortfolioSummary);
export const setIsKycBottomSheetOpen = createAction(
  Actions.setIsKycBottomSheetOpen
);
export const setIsDormatBottomSheetOpen = createAction(
  Actions.setIsDormatBottomSheetOpen
);
export const setIsAccountClosureBottomSheetOpen = createAction(
  Actions.setIsAccountClosureBottomSheetOpen
);
export const getMfPortfolioSummary = createAction(
  Actions.getMfPortfolioSummary
);
export const setMfPortfolioSummary = createAction(
  Actions.setMfPortfolioSummary
);
export const setPfStatusCode = createAction(Actions.setPfStatusCode);
export const setMpfStatusCode = createAction(Actions.setMpfStatusCode);
export const resetPortfolioV2 = createAction(Actions.resetPortfolioV2);
export const getSwitchFundDetails = createAction(Actions.getSwitchFundDetails);
export const setSwitchFundDetails = createAction(Actions.setSwitchFundDetails);
export const getAvailableSwitchFunds = createAction(Actions.getAvailableSwitchFunds);
export const setAvailableSwitchFunds = createAction(Actions.setAvailableSwitchFunds);
export const getCompleteSwitchDetails = createAction(Actions.getCompleteSwitchDetails);
export const setMfWalkthroughInitiated = createAction(
  Actions.setMfWalkthroughInitiated
);
export const setSelectedSwitchToFund = createAction(Actions.setSelectedSwitchToFund);
export const setSwitchOtpDetails = createAction(Actions.setSwitchOtpDetails);
export const getSwitchOtpDetails = createAction(Actions.getSwitchOtpDetails);
export const resendSwitchOtpDetails = createAction(Actions.resendSwitchOtpDetails);
export const verifySwitchOtp = createAction(Actions.verifySwitchOtp);
export const getYourFunds = createAction(Actions.getYourFunds);
export const setYourFunds = createAction(Actions.setYourFunds);
export const setHoldingFundData = createAction(Actions.setHoldingFundData);
export const getFundSips = createAction(Actions.getFundSips);
export const setFundSips = createAction(Actions.setFundSips);
export const getFundOrders = createAction(Actions.getFundOrders);
export const setFundOrders = createAction(Actions.setFundOrders);
export const fetchPendingOrders = createAction(Actions.fetchPendingOrders);
export const setPendingOrders = createAction(Actions.setPendingOrders);
export const setFundOrderData = createAction(Actions.setFundOrderData);
export const fetchAllHoldingFunds = createAction(Actions.fetchAllHoldingFunds);
export const setMoreTransactionsData = createAction(Actions.setMoreTransactionsData);
export const fetchMoreTransactions = createAction(Actions.fetchMoreTransactions);
export const updateFundOrders = createAction(Actions.updateFundOrders);
export const setOrderDetailsFund = createAction(Actions.setOrderDetailsFund);
export const setIsCallPortfolioApis = createAction(Actions.setIsCallPortfolioApis);
export const setYourOrdersStorage = createAction(Actions.setYourOrdersStorage);
export const resetYourOrdersStorage = createAction(Actions.resetYourOrdersStorage);
export const setYourFundsStorage = createAction(Actions.setYourFundsStorage);
export const resetYourFundsStorage = createAction(Actions.resetYourFundsStorage);
export const setAllSipsData = createAction(Actions.setAllSipsData);
export const setUpcomingSipsData = createAction(Actions.setUpcomingSipsData);
export const setSelectedSipData = createAction(Actions.setSelectedSipData);
export const updateSelectedSip = createAction(Actions.updateSelectedSip);
export const updateSipAction = createAction(Actions.updateSipAction);
export const setViewAllSipsStorage = createAction(Actions.setViewAllSipsStorage);
export const resetViewAllSipsStorage = createAction(Actions.resetViewAllSipsStorage);
export const setFundOrderDetails = createAction(Actions.setFundOrderDetails);
export const fetchFundOrderDetails = createAction(Actions.fetchFundOrderDetails);
export const updateEditSipData = createAction(Actions.updateEditSipData);
export const submitSipOtp = createAction(Actions.submitSipOtp);
export const fetchExternalPortfolioSummary = createAction(Actions.fetchExternalPortfolioSummary);
export const setExternalPortfolioSummary = createAction(Actions.setExternalPortfolioSummary);
export const fetchSwitchTaxes = createAction(Actions.fetchSwitchTaxes);

// get functions for portfolio v2
export const getPortfolioSummaryData = (state) => {
  const data = get(state, "portfolioV2.portfolioSummary.data", {});
  return data;
};

export const getPortfolioErrorMessage = (state) => {
  let errorMessage = get(state, "portfolioV2.portfolioSummary.error", "");
  if (!errorMessage) {
    errorMessage = get(state, "portfolioV2.portfolioSummary.message", "");
  }
  return errorMessage;
};

export const getAllocationDetails = (state) => {
  const portfolioSummary = getPortfolioSummaryData(state);
  const data = get(portfolioSummary, "allocation_details", {});
  return data;
};

export const getInvestments = (state) => {
  const portfolioSummary = getPortfolioSummaryData(state);
  const data = get(portfolioSummary, "investments", []);
  return data;
};

export const getInvestmentSummary = (state) => {
  const portfolioSummary = getPortfolioSummaryData(state);
  const data = get(portfolioSummary, "investment_summary", {});
  return data;
};

export const getPortfolioStatusCode = (state) => {
  const data = get(state, "portfolioV2.pfStatusCode", {});
  return data;
};

export const getMfPortfolioStatusCode = (state) => {
  const data = get(state, "portfolioV2.mpfStatusCode", {});
  return data;
};

export const getMfPortfolioSummaryData = (state) => {
  const data = get(
    state,
    "portfolioV2.mfPortfolioSummary.data.mf.portfolio_summary",
    {}
  );
  return data;
};

export const getMfAssetAllocation = (state) => {
  const data = get(
    state,
    "portfolioV2.mfPortfolioSummary.data.mf.asset_allocation",
    {}
  );
  return data;
};

export const getExternalPortfolioDetails = (state) => {
  const data = get(
    state,
    "portfolioV2.externalPortfolioSummary",
    {}
  );
  return data;
};

export const getMfPortfolioErrorMessage = (state) => {
  let errorMessage = get(state, "portfolioV2.mfPortfolioSummary.error", "");
  if (!errorMessage) {
    errorMessage = get(state, "portfolioV2.mfPortfolioSummary.message", "");
  }
  return errorMessage;
};

export const getIsKycSheetOpen = (state) => {
  const data = get(state, "portfolioV2.isKycBottomSheetOpen", false);
  return data;
};

export const getIsDormatSheetOpen = (state) => {
  const data = get(state, "portfolioV2.isDormatBottomSheetOpen", false);
  return data;
};

export const getIsAccountClosureSheetOpen = (state) => {
  const data = get(state, "portfolioV2.isAccountClosureBottomSheetOpen", false);
  return data;
};

// Switch Section get functions
export const getPfSwitchFundDetails = (state) => {
  const data = get(state, "portfolioV2.switchFundDetails", {});
  return data;
}

export const getPfAvailableSwitchFunds = (state) => {
  const data = get(state, "portfolioV2.availableSwitchFunds", []);
  return data;
}

export const getSelectedSwitchToFund = (state) => {
  const data = get(state, "portfolioV2.selectedSwitchToFund", {});
  return data;
}

export const getSwitchOtpDetailsData = (state) => {
  const data = get(state, "portfolioV2.switchOtpDetails", {});
  return data;
}

export const getYourFundSummary = (state) => {
  const data = get(state, "portfolioV2.yourFunds.funds_summary",[]);
  return data;
}

export const getYourFundData = (state) => {
  const yourFunds = get(state, "portfolioV2.yourFunds",{});
  const currentAmount = get(yourFunds, "total_current_amount",0);
  const xirr = get(yourFunds, "xirr",0);
  const data = {
    total_current_amount: currentAmount,
    xirr,
  }
  return data;
}

export const getYourFundsFilterCategory = (state) => {
  const data = get(state, "portfolioV2.yourFunds.filters.category", []);
  return data;
}

export const getYourFundsFilterFundHouses = (state) => {
  const data = get(state, "portfolioV2.yourFunds.filters.fund_houses", []);
  return data;
}

export const getHoldingFundData = (state) => {
  const data = get(state, "portfolioV2.holdingFundData", {});
  return data;
}

export const getFundSipValues = (state) => {
  const data = get(state, "portfolioV2.fundSips", []);
  return data;
}

export const getFundOrderValues = (state) => {
  const data = get(state, "portfolioV2.fundOrders", []);
  return data;
}

export const getPendingOrders = (state) => {
  const data = get(state, "portfolioV2.pendingOrders", []);
  return data;
}

export const getFundOrderData = (state) => {
  const data = get(state, "portfolioV2.fundOrderData", {});
  return data;
}

export const getMoreTransactionsData = (state) => {
  const data = get(state, "portfolioV2.moreTransactionsData", {});
  return data;
}

export const getOrderDetailsFund = (state) => {
  const data = get(state, "portfolioV2.orderDetailsFund", {});
  return data;
}

export const getPortfolioApiCallsValue = (state) => {
  const data = get(state, "portfolioV2.isCallPortfolioApis", {});
  return data;
}

export const getYourOrdersStorage = (state) => {
  const data = get(state, "portfolioV2.yourOrdersStorage", DEFAULT_YOUR_ORDERS_STORAGE);
  return data;
}

export const getYourFundsStorage = (state) => {
  const data = get(state, "portfolioV2.yourFundsStorage", DEFAULT_YOUR_FUNDS_STORAGE);
  return data;
}

export const getAllSipsData = (state) => {
  const data = get(state, "portfolioV2.allSips", {});
  return data;
};

export const getUpcomingSipsData = (state) => {
  const data = get(state, "portfolioV2.upcomingSips", {});
  return data;
};

export const getSipFilterCategories = (state) => {
  const data = get(state, "portfolioV2.allSips.filters.category", []);
  return data;
};

export const getSelectedSipData = (state) => {
  const data = get(state, "portfolioV2.selectedSipData", {});
  return data;
};

export const getViewAllSipsStorage = (state) => {
  const data = get(state, "portfolioV2.viewAllSipsStorage", DEFAULT_VIEW_ALL_SIPS_STORAGE);
  return data;
}

export const getFundOrderDetails = (state) => {
  const data = get(state, "portfolioV2.fundOrderDetails", []);
  return data;
}

const initialState = {
  portfolioSummary: {},
  mfPortfolioSummary: {},
  statusCode: "",
  switchFundDetails: {},
  availableSwitchFunds: [],
  pfStatusCode: "",
  mpfStatusCode: "",
  mfWalkthroughInitiated: false,
  isKycBottomSheetOpen: false,
  isDormatBottomSheetOpen: false,
  isAccountClosureBottomSheetOpen: false,
  selectedSwitchToFund: {},
  switchOtpDetails: {},
  yourFunds: {},
  holdingFundData: {},
  fundSips: [],
  fundOrders: [],
  pendingOrders: [],
  fundOrderData: {},
  moreTransactionsData: {},
  orderDetailsFund: {},
  yourOrdersStorage: DEFAULT_YOUR_ORDERS_STORAGE,
  yourFundsStorage: DEFAULT_YOUR_FUNDS_STORAGE,
  isCallPortfolioApis: {
    isPortfolioApiCall: true,
    isMfPortfolioApiCall: true,
    isYourFundsApiCall: true,
    isYourOrdersApiCall: true,
    isHoldingsApiCall: true,
    isRtaTransactionsApiCall: true,
    isSipLandingApiCall: true,
    isUpcomingSipLandingApiCall: true,
  },
  allSips: {},
  upcomingSips: {},
  selectedSipData : {
    pausePeriod: 1,
  },
  viewAllSipsStorage: DEFAULT_VIEW_ALL_SIPS_STORAGE,
  fundOrderDetails: [],
};

export default createReducer(initialState, (builder) => {
  builder.addCase(setPortfolioSummary, (state, action) => {
    state.portfolioSummary = action.payload;
  });
  builder.addCase(setMfPortfolioSummary, (state, action) => {
    state.mfPortfolioSummary = action.payload;
  });
  builder.addCase(setPfStatusCode, (state, action) => {
    state.pfStatusCode = action.payload;
  });
  builder.addCase(setMpfStatusCode, (state, action) => {
    state.mpfStatusCode = action.payload;
  });
  builder.addCase(resetPortfolioV2, (state, action) => {
    return initialState;
  });
  builder.addCase(setSwitchFundDetails, (state, action) => {
    state.switchFundDetails = action.payload;
  });
  builder.addCase(setAvailableSwitchFunds, (state, action) => {
    state.availableSwitchFunds = action.payload;
  });
  builder.addCase(setMfWalkthroughInitiated, (state, action) => {
    state.mfWalkthroughInitiated = true;
  });
  builder.addCase(setIsKycBottomSheetOpen, (state, action) => {
    state.isKycBottomSheetOpen = action.payload;
  });
  builder.addCase(setIsDormatBottomSheetOpen, (state, action) => {
    state.isDormatBottomSheetOpen = action.payload;
  });
  builder.addCase(setIsAccountClosureBottomSheetOpen, (state, action) => {
    state.isAccountClosureBottomSheetOpen = action.payload;
  });
  builder.addCase(setSelectedSwitchToFund, (state, action) => {
    state.selectedSwitchToFund = action.payload;
  });
  builder.addCase(setSwitchOtpDetails, (state, action) => {
    state.switchOtpDetails = {...state.switchOtpDetails, ...action.payload};
  });
  builder.addCase(setYourFunds, (state, action) => {
    state.yourFunds = action.payload;
  });
  builder.addCase(setHoldingFundData, (state, action) => {
    state.holdingFundData = action.payload;
  });
  builder.addCase(setFundSips, (state, action) => {
    state.fundSips = action.payload;
  });
  builder.addCase(setFundOrders, (state, action) => {
    state.fundOrders = action.payload;
  });
  builder.addCase(updateFundOrders, (state, action) => {
    state.fundOrders = [ ...state.fundOrders, ...action.payload ];
  });
  builder.addCase(setPendingOrders, (state, action) => {
    state.pendingOrders = action.payload;
  });
  builder.addCase(setFundOrderData, (state, action) => {
    state.fundOrderData = action.payload;
  });
  builder.addCase(setOrderDetailsFund, (state, action) => {
    state.orderDetailsFund = action.payload;
  });
  builder.addCase(setMoreTransactionsData, (state, action) => {
    state.moreTransactionsData = action.payload;
  });
  builder.addCase(setIsCallPortfolioApis, (state, action) => {
    state.isCallPortfolioApis = {...state.isCallPortfolioApis, ...action.payload};
  });
  builder.addCase(setYourOrdersStorage, (state, action) => {
    state.yourOrdersStorage = { ...state.yourOrdersStorage, ...action.payload };
  });
  builder.addCase(resetYourOrdersStorage, (state, action) => {
    state.yourOrdersStorage = {
      ...DEFAULT_YOUR_ORDERS_STORAGE,
      ...action.payload,
    };
  });
  builder.addCase(setYourFundsStorage, (state, action) => {
    state.yourFundsStorage = { ...state.yourFundsStorage, ...action.payload };
  });
  builder.addCase(resetYourFundsStorage, (state) => {
    state.yourFundsStorage = DEFAULT_YOUR_FUNDS_STORAGE;
  });
  builder.addCase(setAllSipsData, (state, action) => {
    state.allSips = action.payload;
  });
  builder.addCase(setUpcomingSipsData, (state, action) => {
    state.upcomingSips = action.payload;
  });
  builder.addCase(setSelectedSipData, (state, action) => {
    state.selectedSipData = {...action.payload, pausePeriod: 1}
  });
  builder.addCase(updateSelectedSip, (state, action) => {
    state.selectedSipData = {...state.selectedSipData, ...action.payload}
  })
  builder.addCase(setViewAllSipsStorage, (state, action) => {
    state.viewAllSipsStorage = { ...state.viewAllSipsStorage, ...action.payload };
  });
  builder.addCase(resetViewAllSipsStorage, (state) => {
    state.viewAllSipsStorage = DEFAULT_VIEW_ALL_SIPS_STORAGE;
  });
  builder.addCase(setFundOrderDetails, (state, action) => {
    state.fundOrderDetails = action.payload;
  });
  builder.addCase(setExternalPortfolioSummary, (state, action) => {
    state.externalPortfolioSummary = action.payload;
  });
});
